function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext, useMemo } from 'react';
import { MediaContext } from 'react-media-query-hoc';
import { AdProvider } from '@domain-group/fe-co-allhomes-ads';
import AllhomesAuthentication from '@domain-group/fe-co-allhomes-authentication';
import { AnalyticsProvider } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import primaryNav from './menu';
import { SeparatorMenuItem } from './components/menu/menu';
import DesktopHeader from './desktop-header';
import TouchHeader from './touch-header';
import eventMapper from './analytics/event-mapper';
import { jsx as ___EmotionJSX } from "@emotion/core";
var useAppearance = appearanceProp => {
  var media = useContext(MediaContext);
  if (appearanceProp !== 'auto') {
    return appearanceProp;
  }
  if (media.desktopNewHeader) {
    return 'desktop';
  }
  if (media.tablet || media.desktop) {
    return 'tablet';
  }
  return 'mobile';
};
var AllhomesHeader = _ref => {
  var _ref$appearance = _ref.appearance,
    appearanceProp = _ref$appearance === void 0 ? 'auto' : _ref$appearance,
    _ref$logoType = _ref.logoType,
    logoType = _ref$logoType === void 0 ? 'normal' : _ref$logoType,
    activeNavItem = _ref.activeNavItem,
    showMediaBanner = _ref.showMediaBanner,
    _ref$enableAds = _ref.enableAds,
    enableAds = _ref$enableAds === void 0 ? false : _ref$enableAds,
    adIds = _ref.adIds,
    sendEvent = _ref.sendEvent;
  var appearance = useAppearance(appearanceProp);
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  var filterItems = useMemo(() => menuItem => menuItem !== SeparatorMenuItem && menuItem.showOn ? menuItem.showOn.includes(appearance) : true, [appearance]);
  var navigationItems = useMemo(() => primaryNav.map(menuGroup => menuGroup.filter(filterItems).map(menuItem => menuItem !== SeparatorMenuItem && 'items' in menuItem ? _objectSpread(_objectSpread({}, menuItem), {}, {
    items: menuItem.items.filter(filterItems).filter(menuSubitem => menuSubitem === SeparatorMenuItem || !menuSubitem.toggledFeature || toggledFeatures[menuSubitem.toggledFeature])
  }) : menuItem)), [filterItems, toggledFeatures]);
  var logoVariant = logoType === 'normal' ? 'color' : logoType;
  var menuProps = {
    logoType: logoVariant,
    navigationItems,
    activeItem: activeNavItem,
    adIds
  };
  var disableAds = !(enableAds && adIds);
  return ___EmotionJSX(AnalyticsProvider, {
    eventMapper: eventMapper,
    sendEvent: sendEvent
  }, ___EmotionJSX(AdProvider, {
    disableAds: disableAds
  }, ___EmotionJSX(AllhomesAuthentication, null), appearance === 'desktop' ? ___EmotionJSX(DesktopHeader, _extends({}, menuProps, {
    showMediaBanner: showMediaBanner
  })) : ___EmotionJSX(TouchHeader, _extends({}, menuProps, {
    appearance: appearance === 'mobile' ? 'compact' : 'full'
  }))));
};
export default AllhomesHeader;